import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { PasswordChangedSuccessDialogComponent } from '../components/password-changed-success-dialog/password-changed-success-dialog.component';
import { SecurityPrivacyCookiePolicyComponent } from '../components/security-privacy-cookie-policy/security-privacy-cookie-policy.component';
import { TermsAndConditionsComponent } from '../components/terms-and-conditions/terms-and-conditions.component';
import { SessionTimeoutDialogComponent } from '../components/session-timeout-dialog/session-timeout-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {   

  constructor(private matDialog: MatDialog) { }

  showPasswordChangedSuccessDialog() {
    return this.OpenSingletonModal(PasswordChangedSuccessDialogComponent);
  }

  showSecurityPrivacyCookiePolicyModal() {
    return this.OpenSingletonModal(SecurityPrivacyCookiePolicyComponent);
  }

  showTermsAndConditionsModal() {
    return this.OpenSingletonModal(TermsAndConditionsComponent);
  }

  showSessionTimeoutWarning() {
    return this.OpenSingletonModal(SessionTimeoutDialogComponent);
  }

  // Ensure that only one instance of a given modal is open at a time
  private OpenSingletonModal(component: any) {
    const openDialogs = this.matDialog.openDialogs;
    const existingDialog = openDialogs.find(dialog => dialog.componentInstance instanceof component); 
    return existingDialog ?? this.matDialog.open(component,{panelClass:'dialog-panel-large' });
  }
}
